import { jsx as m } from "react/jsx-runtime";
import { memoize as D } from "lodash-es";
import E, { useState as I, useRef as b, useEffect as i, useCallback as y } from "react";
import { useDebounce as R } from "react-use";
import { I as S } from "../../constants-C9JADvZj.mjs";
import { StyledInputMask as _ } from "./styled.js";
const x = D(
  (e, r) => {
    switch (r) {
      case "FullDate":
        return {
          placeholder: `DD ${e} MM ${e} YYYY`,
          mask: `99 ${e} 99 ${e} 9999`
        };
      case "MonthYear":
        return {
          placeholder: `MM ${e} YYYY`,
          mask: `99 ${e} 9999`
        };
      case "MonthYearShort":
        return {
          placeholder: `MM ${e} YY`,
          mask: `99 ${e} 99`
        };
    }
  },
  (e, r) => `${e}|${r}`
), F = ({
  maskChar: e = null,
  mode: r = "FullDate",
  divider: p = "/",
  field: t,
  meta: l,
  ariaLabel: h = "date",
  disabled: u,
  delay: f = S,
  placeholder: Y
}) => {
  const [$, s] = I(""), { value: n } = t, a = b(), c = !!(l.touched && l.error);
  R(
    () => {
      a.current && t.onChange(a.current);
    },
    f,
    [a.current]
  ), i(() => {
    s(n || "");
  }, [n]);
  const M = y((o) => {
    o.persist(), s(o.currentTarget.value), a.current = o;
  }, []), { placeholder: g, mask: k } = x(p, r);
  return (
    // @ts-expect-error - styled-components typing strips the renderProp method of rendering the component
    /* @__PURE__ */ m(
      _,
      {
        ...t,
        isError: c,
        mode: r,
        value: $,
        onChange: M,
        placeholder: Y ?? g,
        "aria-label": h,
        mask: k,
        disabled: u,
        maskChar: e,
        "aria-invalid": !!c,
        "aria-labelledby": `${t.name}.label`,
        autoComplete: "off",
        children: ({ isError: o, ...C }) => /* @__PURE__ */ m("input", { disabled: u, type: "tel", ...C })
      }
    )
  );
}, A = E.memo(F);
export {
  A as default
};
